<app-component-header></app-component-header>

<div class="component-block">
    <section class="block-formControlWrap">
        <div class="container">
            <div class="row">
                <div class="margin-bottom-5">
                    <div class="col-xs-6">
                        <div class="page-head">
                            <div class="page-title">

                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="block-formControl">
                        <div class="section-title-wrapper">
                            <span class="section-title">
                                Xác nhận từ khách hàng
                            </span>
                        </div>
                        <div class="section">
                            <div class="row">
                                <div class="text-left" style="padding:10px;vertical-align:central">
                                    <span>Bằng việc nhấn vào Từ chối/đồng ý bên dưới, Tôi/Chúng tôi xác nhận sử dụng
                                        email đã đăng ký tại SACOMBANK cho các mục đích theo email mà SACOMBANK đã gửi
                                        cho Tôi/Chúng tôi.</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="clear-flex" style="width: 15%">&nbsp;</div>
                                <button class="accept" (click)="receiveEmail()">
                                    Đồng ý
                                </button>
                                <div class="clear-flex" style="width: 20%;">&nbsp;</div>
                                <button class="nope" (click)="nopeReceiveEmail()">
                                    Từ chối
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>
<div *ngIf="isLoading" class="loading-container">
    <div class="loading-spin">
        <ng-template #indicatorTemplate><i nz-icon nzType="loading"></i></ng-template>
        <nz-spin nzSimple [nzSize]="'large'" [nzIndicator]="indicatorTemplate"></nz-spin>
    </div>
</div>

<app-component-footer></app-component-footer>